import React from 'react';

export const Reports: React.FC<{}> = (props) => {
  return (
    <>
      <h1>Reports</h1>
    </>
  );
};
